"use client";

import createSvgIcon from './utils/createSvgIcon';
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon( /*#__PURE__*/_jsx("path", {
  fillRule: "evenodd",
  d: "M5.26 11h13.48l-.67 9H5.93zm3.76-7h5.95L19 7.38l1.59-1.59L22 7.21 19.21 10H4.79L2 7.21 3.41 5.8 5 7.38z"
}), 'TakeoutDining');


//////////////////
// WEBPACK FOOTER
// ./node_modules/@mui/icons-material/esm/TakeoutDining.js
// module id = 11698
// module chunks = 0